export default __webpack_public_path__ + "static/12-a497a8757dbc6ab7565ec6cb449b5b34.webp";